import { render, staticRenderFns } from "./injectInfo.vue?vue&type=template&id=75bd52e6&scoped=true&"
import script from "./injectInfo.vue?vue&type=script&lang=js&"
export * from "./injectInfo.vue?vue&type=script&lang=js&"
import style0 from "./injectInfo.vue?vue&type=style&index=0&id=75bd52e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bd52e6",
  null
  
)

export default component.exports